/******************************
 ** Easings
 ******************************/

export const easing = {
  FUNC_ENTER:"Functional-Enter",
  FUNC_EXIT:"Functional-Exit",
  FUNC:"Functional-Standard",
  EXP_ENTER:"Expressive-Enter",
  EXP_EXIT:"Expressive-Exit",
  EXP:"Expressive-Standard",
}

export const easingValues = {
  "Functional-Enter": "cubic-bezier(0, 0, 0.3, 1)",
  "Functional-Exit": "cubic-bezier(0.7, 0, 1, 1)",
  "Functional-Standard": "cubic-bezier(0.7, 0, 0.3, 1)",
  "Expressive-Enter": "cubic-bezier(0, 0, 0.3, 1.3)",
  "Expressive-Exit": "cubic-bezier(0.7, -0.3, 1, 1)",
  "Expressive-Standard": "cubic-bezier(0.7, -0.3, 0.3, 1.3)",
};
